import type {
    LeadTimeService,
    LeadTimeItem,
    LeadTimeHistoryEntry,
    LeadTimeChange,
} from '../types';

/**
 * Lead-time attributes service.
 *
 * The backend endpoints (item catalog, per-item audit history, batch save) are
 * not built yet, so this returns empty data and no-ops on save. The Lead Time
 * screen is fully wired to these methods, so it will populate automatically
 * once the real implementation lands here.
 */
export const awsLeadTimeService: LeadTimeService = {
    async listItems(): Promise<LeadTimeItem[]> {
        return [];
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getHistory(item: string): Promise<LeadTimeHistoryEntry[]> {
        return [];
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async saveChanges(changes: LeadTimeChange[]): Promise<void> {
        // No-op until the backend save endpoint exists.
    },
};

export default awsLeadTimeService;
